import { TemplateNames } from '@anm/api/modules/hosting';
import SelectionList, { ChangeHandler } from '@anm/components/list/SelectionList';
import SectionTitle from '@anm/components/video-landings/SectionTitle';
import { layoutSelection } from '@anm/data/video-landings/selection';
import debounce from 'lodash/fp/debounce';
import { FC } from 'react';
import styled from 'styled-components';

type LayoutSelectionProps = ChangeHandler & {
  paidLayouts?: TemplateNames[];
  selectedLayoutIndex?: number;
};

const Wrapper = styled.div`
  margin-bottom: 22px;
`;

const LayoutSelection: FC<LayoutSelectionProps> = ({ onChange, paidLayouts, selectedLayoutIndex = 0 }) => {
  const handleLayoutChange = debounce(300, onChange);

  return (
    <Wrapper>
      <SectionTitle level={2} title="Layout" />
      <SelectionList
        onChange={handleLayoutChange}
        list={layoutSelection.map(l => ({
          ...l,
          isPaid: paidLayouts?.includes(l.name)
        }))}
        selectedItemIndexes={[selectedLayoutIndex]}
        containActiveIcons={true}
      />
    </Wrapper>
  );
};

export default LayoutSelection;
